import { Route, Routes } from "react-router-dom";
import "./App.css";

import ProtectedRoute from "./Utils/ProtectedRoute";
import Unauthorized from "./Utils/Unauthorized";

import HomePage from "./AllComponents/CommonComponents/HomePage";
import Dashboard from "./AllComponents/AdminComponents/Dashboard";

import StudentAdmissionForm from "./AllComponents/StudentsFormComponent/StudentAdmissionForm";
import ParentsDocumentForm from "./AllComponents/StudentsFormComponent/ParentsDocumentForm";
import PoliceDocumentForm from "./AllComponents/StudentsFormComponent/PoliceDocumentForm";
import RoomAllocationForm from "./AllComponents/StudentsFormComponent/RoomAllocationForm";
import ChildrenHomeVisitForm from "./AllComponents/StudentsFormComponent/ChildrenHomeVisitForm";
import NamunaForm from "./AllComponents/StudentsFormComponent/NamunaForm";
import EducationalDocumentsForm from "./AllComponents/StudentsFormComponent/EducationalDocumentsForm";
import MedicalDocumentsForm from "./AllComponents/StudentsFormComponent/MedicalDocumentsForm";
import GirlStatementForm from "./AllComponents/StudentsFormComponent/GirlStatementForm";
import CaseFileForm from "./AllComponents/StudentsFormComponent/CaseFileForm";
import DischargeForm from "./AllComponents/StudentsFormComponent/DischargeForm";

import ReligionMaster from "./AllComponents/AdminComponents/Masters/ReligionMaster";
import CastMaster from "./AllComponents/AdminComponents/Masters/CastMaster";
import SubCastMaster from "./AllComponents/AdminComponents/Masters/SubCastMaster";
import ActAndSectionMaster from "./AllComponents/AdminComponents/Masters/ActAndSectionMaster";
import BuildingMaster from "./AllComponents/AdminComponents/Masters/BuildingMaster";
import FloorMaster from "./AllComponents/AdminComponents/Masters/FloorMaster";

import MenuMaster from "./AllComponents/AdminComponents/AdminPages/MenuMaster";
import PageMaster from "./AllComponents/AdminComponents/AdminPages/PageMaster";
import RoleAllocation from "./AllComponents/AdminComponents/AdminPages/RoleAllocation";
import UserCreation from "./AllComponents/AdminComponents/AdminPages/UserCreation";
import CounsellorForm from "./AllComponents/StudentsFormComponent/CounsellorForm";
import ExtensionEntry from "./AllComponents/AdminComponents/AdminPages/ExtensionEntry";
import AdmissionReport from "./AllComponents/AdminComponents/Reports/AdmissionReport";
import ParentInfoReport from "./AllComponents/AdminComponents/Reports/ParentInfoReport";
import PoliceInfoReport from "./AllComponents/AdminComponents/Reports/PoliceInfoReport";
import HomeVisitReport from "./AllComponents/AdminComponents/Reports/HomeVisitReport";
import EducationDocumentReport from "./AllComponents/AdminComponents/Reports/EducationalInfoReport";
import MedicalDocumentReport from "./AllComponents/AdminComponents/Reports/MedicalDocumentReport";
import CaseFileReport from "./AllComponents/AdminComponents/Reports/CaseFileReport";
import DischargeReport from "./AllComponents/AdminComponents/Reports/DischargeReport";
import CounsellingReport from "./AllComponents/AdminComponents/Reports/CounsellingReport";
import GirlStatementReport from "./AllComponents/AdminComponents/Reports/GirlStatementReport";
import RoomAllocationReport from "./AllComponents/AdminComponents/Reports/RoomAllocationReport";
import NamunaFormReport from "./AllComponents/AdminComponents/Reports/NamunaFormReport";

function App() {
  return (
    <Routes>
      {/* Public Route */}
      <Route path="/" element={<HomePage />} />

      {/* Unauthorized Page */}
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* Dashboard */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* ===== Forms ===== */}
      <Route path="/form1" element={<ProtectedRoute pageId={7}><StudentAdmissionForm /></ProtectedRoute>} />
      <Route path="/form2" element={<ProtectedRoute pageId={8}><ParentsDocumentForm /></ProtectedRoute>} />
      <Route path="/form3" element={<ProtectedRoute pageId={9}><PoliceDocumentForm /></ProtectedRoute>} />
      <Route path="/form4" element={<ProtectedRoute pageId={10}><RoomAllocationForm /></ProtectedRoute>} />
      <Route path="/form5" element={<ProtectedRoute pageId={11}><ChildrenHomeVisitForm /></ProtectedRoute>} />
      <Route path="/form6" element={<ProtectedRoute pageId={12}><NamunaForm /></ProtectedRoute>} />
      <Route path="/form7" element={<ProtectedRoute pageId={13}><EducationalDocumentsForm /></ProtectedRoute>} />
      <Route path="/form8" element={<ProtectedRoute pageId={14}><MedicalDocumentsForm /></ProtectedRoute>} />
      <Route path="/form9" element={<ProtectedRoute pageId={15}><GirlStatementForm /></ProtectedRoute>} />
      <Route path="/form10" element={<ProtectedRoute pageId={16}><CaseFileForm /></ProtectedRoute>} />
      <Route path="/form11" element={<ProtectedRoute pageId={17}><CounsellorForm /></ProtectedRoute>} />
      <Route path="/form12" element={<ProtectedRoute pageId={18}><DischargeForm /></ProtectedRoute>} />

      {/* ===== Masters ===== */}
      <Route path="/m1" element={<ProtectedRoute pageId={1}><ReligionMaster /></ProtectedRoute>} />
      <Route path="/m2" element={<ProtectedRoute pageId={2}><CastMaster /></ProtectedRoute>} />
      <Route path="/m3" element={<ProtectedRoute pageId={3}><SubCastMaster /></ProtectedRoute>} />
      <Route path="/m4" element={<ProtectedRoute pageId={4}><ActAndSectionMaster /></ProtectedRoute>} />
      <Route path="/m5" element={<ProtectedRoute pageId={5}><BuildingMaster /></ProtectedRoute>} />
      <Route path="/m6" element={<ProtectedRoute pageId={6}><FloorMaster /></ProtectedRoute>} />

      {/* ===== Admin Pages ===== */}
      <Route path="/a1" element={<ProtectedRoute pageId={19}><MenuMaster /></ProtectedRoute>} />
      <Route path="/a2" element={<ProtectedRoute pageId={20}><PageMaster /></ProtectedRoute>} />
      <Route path="/a3" element={<ProtectedRoute pageId={21}><RoleAllocation /></ProtectedRoute>} />
      <Route path="/a4" element={<ProtectedRoute pageId={22}><UserCreation /></ProtectedRoute>} />
      <Route path="/a5" element={<ProtectedRoute pageId={23}><ExtensionEntry /></ProtectedRoute>} />

      {/* ===== Admin Pages ===== */}
      <Route path="/r1" element={<ProtectedRoute pageId={24}><AdmissionReport /></ProtectedRoute>} />
      <Route path="/r2" element={<ProtectedRoute pageId={25}><ParentInfoReport /></ProtectedRoute>} />
      <Route path="/r3" element={<ProtectedRoute pageId={26}><PoliceInfoReport /></ProtectedRoute>} />
      <Route path="/r4" element={<ProtectedRoute pageId={33}><RoomAllocationReport /></ProtectedRoute>} />
      <Route path="/r5" element={<ProtectedRoute pageId={27}><HomeVisitReport /></ProtectedRoute>} />
      <Route path="/r6" element={<ProtectedRoute pageId={33}><NamunaFormReport /></ProtectedRoute>} />
      <Route path="/r7" element={<ProtectedRoute pageId={28}><EducationDocumentReport /></ProtectedRoute>} />
      <Route path="/r8" element={<ProtectedRoute pageId={29}><MedicalDocumentReport /></ProtectedRoute>} />
      <Route path="/r9" element={<ProtectedRoute pageId={30}><GirlStatementReport /></ProtectedRoute>} />
      <Route path="/r10" element={<ProtectedRoute pageId={31}><CaseFileReport /></ProtectedRoute>} />
      <Route path="/r11" element={<ProtectedRoute pageId={32}><CounsellingReport /></ProtectedRoute>} />
      <Route path="/r12" element={<ProtectedRoute pageId={33}><DischargeReport /></ProtectedRoute>} />
    </Routes>
  );
}

export default App;